<template>
  <div class="showcase-hero" :class="{ scrolled: $store.state.page.scrolled }">
    <div
      class="showcase-hero__background"
      data-in-out
      data-in-out-animation="slide-no-alpha"
      data-in-out-no-menu
      data-out-delay="0.4"
    ></div>
    <!-- <div
      class="showcase__text-wrapper"
      data-in-out
      data-in-out-animation="slide"
      data-in-out-no-menu
    >
      <div
        class="showcase-hero__text"
        data-in-out
        data-in-out-animation="slide"
      >
        <p>
          Cuvée 1821isn’t alone in its journey.<br>
          Discover more of Zonin’s Prosecco flavor and appeal in its family!
        </p>
      </div>
    </div> -->
    <div
      class="showcase-hero__title-wrapper"
      data-in-out
      data-in-out-animation="stagger-text"
      data-in-delay="0.4"
    >
      <h1 class="showcase-hero__title">{{ title }}</h1>
    </div>
  </div>
</template>

<script>
import { SplitText } from '@/scripts/libs/SplitText';

export default {
  name: 'ShowcaseHero',

  props: ['title', 'text'],

  mounted() {
    new SplitText(this.$el.querySelector('h1'), { charsClass: 'stagger-element' }); // eslint-disable-line
  },
};
</script>

<style lang="scss" scoped>
.showcase-hero {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);

  &__background {
    @extend %full;
    background-color: $color-black;
  }

  h1 {
    position: relative;
    font-size: rem(250px);
    font-size: calc(250px * var(--rw));
    color: $color-white;
    font-weight: 300;
    top: calc((100vh / 18) * 4);
    left: calc((100vw / 32) * 7);
    line-height: 1;
    transition: opacity 0.6s $inOutCubic,
                transform 0.6s $inOutCubic;

    @include mq($until: ds) {
      font-size: rem(220px);
      font-size: calc(220px * var(--rw));
      left: calc((100vw / 32) * 4);
    }

    @include mq($until: ipadP) {
      font-size: rem(80px);
      font-size: calc(80px * var(--rw));
      left: calc((100vw / 32) * 4);
      top: calc((100vh / 18) * 6);
    }
  }

  p {
    transition: opacity 0.6s $inOutCubic,
                transform 0.6s $inOutCubic;
  }

  &__text {
    position: absolute;
    top: calc((100vh / 18) * 4);
    right: calc((100vw / 32) * 7);
    color: $color-white;
    width: calc((100vw / 32) * 9);
    font-size: rem(20px);
    font-size: $font-size-text;
    transition: transform 0.6s $inOutCubic,
                opacity 0.6s $inOutCubic;

    @include mq($until: ipadL) {
      left: calc((100vw / 32) * 4);
      width: calc(100% - ((100vw / 32) * 8));
      top: calc((100vh / 18) * 6);
      right: auto;
    }
  }

  &.scrolled {
    h1 {
      opacity: 0;
      transform: translateY(-80px);
    }

    p {
      opacity: 0;
      transform: translateY(-80px);
    }

    .showcase-hero__text {
      opacity: 0;
      transform: translateY(80px);
    }
  }
}
</style>
